import { InlineErrorMessage } from '@lotta/self-service/lottery-fe/ui-common';
import { useTranslation } from 'react-i18next';

export const ConfirmLotteryError: React.FC<{
  titleTranslationKey: string;
  bodyTranslationKey: string;
}> = ({ titleTranslationKey, bodyTranslationKey }) => {
  const { t } = useTranslation();
  return <InlineErrorMessage body={t(bodyTranslationKey)} title={t(titleTranslationKey)} />;
};
